import * as Yup from 'yup';

import { CasReactHookFormDialog, CasRHFTextField } from 'src/compass/shared/components';
import { getStringSchema } from 'src/compass/shared/schemas';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { StatusButtonConfig } from './ClaimTrackingStatusActions';

type EnterActionReasonDialogProps = StatusButtonConfig & {
  title: string;
  status: string;
  onClose: VoidFunction;
  endorsementId: number;
  onUpdated: Function;
};

const ReasonFieldSchema = Yup.object().shape({
  reason: getStringSchema(100, 'Reason'),
});

export default function EnterActionReasonDialog({
  title,
  url,
  endorsementId,
  status,
  onClose,
  onUpdated,
}: EnterActionReasonDialogProps) {
  const { mutate } = useUpdateMutation({
    url,
    onSuccess: (response) => {
      onSuccessEnqueueSnackbar(response);
      onUpdated();
      onClose();
    },
  });

  const onSubmit = ({ reason }: any) => mutate({ endorsementId, status, reason });

  return (
    <CasReactHookFormDialog
      open
      onSubmit={onSubmit}
      onClose={onClose}
      title={title}
      submitButtonLabel="Save"
      schema={ReasonFieldSchema}
    >
      <CasRHFTextField label="Reason" name="reason" />
    </CasReactHookFormDialog>
  );
}
